// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__F0u7Z","text":"style_text__2qoFp","btn":"style_btn__5Or0F"};